import { createContext } from 'react';

const defaultData: NavigationContextType = {
  urls: {},
  accountAccessModal: {
    show: false,
    hideNavigation: true,
    handleToggle: () => true
  },
  accountListModal: {
    show: false,
    hideNavigation: true,
    handleToggle: () => true
  },
  helpModal: {
    show: false,
    hideNavigation: true,
    handleToggle: () => true
  },
  legalAgreementModal: {
    show: false,
    hideNavigation: true,
    handleToggle: () => true
  },
  navigationBar: {
    show: true,
    hideNavigation: false,
    handleToggle: () => true
  }
};

export default createContext(defaultData);
